import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js/index.jsx';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import SearchBar from '../../Components/SearchBar/index.jsx';

const AboutUs = () => {
  const { backgroundColor } = useActiveComponent();
  const [imageUrls, setImageUrls] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fontColor = backgroundColor === '#ffffff' ? '#030202' : 'lightgrey';

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const storage = getStorage();
        const images = {
          aboutImage0: 'siteImages/homeBanner1.jpg',
          aboutImage1: 'siteImages/aboutImage1.jpg',
          aboutImage2: 'siteImages/aboutImage2.jpg',
          aboutImage3: 'siteImages/aboutImage3.jpg',
        };
        const urls = {};
        // for (const [key, path] of Object.entries(images)) {
        //   const url = await getDownloadURL(ref(storage, path));
        //   urls[key] = url;
        // }
        // Use Promise.all to fetch all image URLs concurrently
        await Promise.all(
          Object.entries(images).map(async ([key, path]) => {
            const url = await getDownloadURL(ref(storage, path));
            urls[key] = url;
          })
        );
        setImageUrls(urls);
        setIsLoading(false); // Stop loading once all images are fetched
      } catch (error) {
        console.error('Error fetching images:', error);
        setIsLoading(false); // Stop loading in case of an error
      }
    };
    fetchImages();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          height: '100vh', // Full viewport height
          overflowY: 'auto', // Enable vertical scrolling of entire homepage
          mb: 0,
        }}
      >
        {/* Sticky header section with Typography and Tabs */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1000, // Ensure it's above other content while scrolling
            backgroundColor: backgroundColor, // Set background so it's visible while scrolling
            p: 0.5,
          }}
        >
          <Box
            sx={{
              display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'white',
              pb: 0.5,
              height: 45,
              ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
              position: 'sticky',
              top: 0,
              zIndex: 1000, // Ensure it's above other content while scrolling
              mb: 1,
            }}
          >
            <SearchBar width={300} />
          </Box>
          <Box
            p={0}
            mt={0}
            mb={0}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='h4'
              noWrap
              component='div'
              sx={{
                mt: 1,
                display: { xs: 'flex', md: 'flex' },
                fontFamily: 'Montserrat',
                letterSpacing: '.3rem',
                fontSize: { xs: 12, sm: 12, md: 13, lg: 15, xl: 15 },
                flexDirection: 'center',
                color: fontColor,
                textDecoration: 'none',
                cursor: 'pointer', // Change cursor to pointer to indicate it's clickable
              }}
            >
              About
            </Typography>
          </Box>
        </Box>

        {/* SECTION 1 */}
        {/* {imageUrls.aboutImage1 && ( */}
        <Box
          component='img'
          src={imageUrls.aboutImage0 || './images/siteImages/aboutImage0.png'}
          alt='About Us Image-1'
          sx={{
            width: {
              xs: 330,
              sm: 330,
              md: 360,
              lg: 1200,
              xl: 1200,
            },
            height: 'auto',
            borderRadius: '14px',
            display: 'block',
            margin: 'auto',
            mt: 1,
            mb: 2,
          }}
        />
        {/* )} */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: {
              xs: 'column',
              sm: 'column',
              md: 'column',
              lg: 'row',
              xl: 'row',
            },
            width: { xs: '80%', sm: '90%', md: '80%', lg: '100%', xl: '100%' },
            ml: 'auto',
            mr: 'auto',
            p: 0,
            mt: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
            mb: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
          }}
        >
          <Typography
            variant='body1'
            // noWrap
            component='div'
            sx={{
              width: { xs: 300, sm: 400, md: 480, lg: '80%', xl: '80%' },
              display: { xs: 'flex', md: 'flex' },
              // fontFamily: 'Roboto',
              fontFamily: 'Montserrat',
              fontWeight: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
              letterSpacing: '0rem',
              fontSize: { xs: 9, sm: 9, md: 14, lg: 16, xl: 16 },
              //flexDirection: 'center',
              color: fontColor,
              textDecoration: 'none',
              whiteSpace: 'pre-line',
              textAlign: 'justify',
            }}
          >
            At Xploras360, we understand the challenges of navigating life in a
            new country or city. Whether you’re an expat, a digital nomad, a
            traveler, or an explorer, finding essential services in an
            unfamiliar place can feel overwhelming. But that’s where we come in!
            Xploras360 is a modern platform creating a vibrant community of
            users bridging the gap between those in search of services and those
            offering them, all around the world. Our mission is simple: to make
            your transition to a new location as smooth and seamless as
            possible. By connecting you with a diverse range of local offerings,
            we empower you to discover the best your new home has to offer.
          </Typography>
        </Box>

        {/* Section2 */}
        {imageUrls.aboutImage2 && (
          <Box
            component='img'
            src={imageUrls.aboutImage2 || './images/siteImages/aboutImage2.jpg'}
            alt='About Us Image-1'
            sx={{
              width: {
                xs: 330,
                sm: 330,
                md: 360,
                lg: 1200,
                xl: 1200,
              },
              height: 'auto',
              borderRadius: '14px',
              display: 'block',
              margin: 'auto',
              mt: 1,
              mb: 2,
            }}
          />
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: {
              xs: 'column',
              sm: 'column',
              md: 'column',
              lg: 'row',
              xl: 'row',
            },
            width: { xs: '80%', sm: '90%', md: '80%', lg: '100%', xl: '100%' },
            ml: 'auto',
            mr: 'auto',
            p: 0,
            mt: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
            mb: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
          }}
        >
          <Typography
            variant='body1'
            // noWrap
            component='div'
            sx={{
              width: { xs: 300, sm: 400, md: 480, lg: '80%', xl: '80%' },
              display: { xs: 'flex', md: 'flex' },
              fontFamily: 'Montserrat',
              fontWeight: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
              letterSpacing: '0rem',
              fontSize: { xs: 9, sm: 9, md: 14, lg: 16, xl: 16 },
              color: fontColor,
              textDecoration: 'none',
              whiteSpace: 'pre-line',
              textAlign: 'justify',
            }}
          >
            For Expats, Nomads, and Travelers, moving to a new place brings both
            excitement and uncertainty. Xploras360 helps take the guesswork out
            of finding essential services. Whether you're searching for a visa
            consultant, a great place to eat, or someone to assist with language
            translation, our community-driven platform connects you with the
            services you need, so you can focus on enjoying your new adventure.
            For Local Providers, if you offer services that can make life easier
            for new arrivals, Xploras360 is your gateway to connect with expats
            and travelers. Share your offerings and reach a wider audience
            through our global community.
          </Typography>
        </Box>

        {/* SECTION 3 */}

        {imageUrls.aboutImage3 && (
          <Box
            component='img'
            src={imageUrls.aboutImage3 || './images/siteImages/aboutImage3.jpg'}
            alt='About Us Image-1'
            sx={{
              width: {
                xs: 330,
                sm: 330,
                md: 360,
                lg: 1200,
                xl: 1200,
              },
              height: 'auto',
              borderRadius: '14px',
              display: 'block',
              margin: 'auto',
              mt: 1,
              mb: 2,
            }}
          />
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: {
              xs: 'column',
              sm: 'column',
              md: 'column',
              lg: 'row',
              xl: 'row',
            },
            width: { xs: '80%', sm: '90%', md: '80%', lg: '100%', xl: '100%' },
            ml: 'auto',
            mr: 'auto',
            p: 0,
            mt: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
            mb: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3 },
          }}
        >
          <Typography
            variant='body1'
            // noWrap
            component='div'
            sx={{
              width: { xs: 300, sm: 400, md: 480, lg: '80%', xl: '80%' },
              display: { xs: 'flex', md: 'flex' },
              fontFamily: 'Montserrat',
              fontWeight: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
              letterSpacing: '0rem',
              fontSize: { xs: 9, sm: 9, md: 14, lg: 16, xl: 16 },
              color: fontColor,
              textDecoration: 'none',
              whiteSpace: 'pre-line',
              textAlign: 'justify',
            }}
          >
            Xploras360 is more than just a service directory. We are a
            community-driven platform where people from all walks of life can
            connect, share experiences, and help each other thrive in new
            environments. We believe in the power of connection, and we are
            committed to creating a space where trust and reliability are the
            foundation of every interaction. Whether you're looking for services
            or offering them, Xploras360 is your go-to hub for making meaningful
            connections across the globe. We are here to make your journey
            smoother, your experience richer, and your new city feel like home.
            Welcome to Xploras360, where the world comes together.
          </Typography>
        </Box>
        {imageUrls.aboutImage1 && (
          <Box
            component='img'
            // src={'./images/siteImages/aboutImage3.jpg'}
            src={imageUrls.aboutImage1 || './images/siteImages/aboutImage3.jpg'}
            alt='About Us Image-1'
            sx={{
              width: {
                xs: 330,
                sm: 330,
                md: 360,
                lg: 1200,
                xl: 1200,
              },
              height: 'auto',
              borderRadius: '14px',
              display: 'block',
              margin: 'auto',
              mt: 0,
              mb: 8,
            }}
          />
        )}
      </Box>
      {/* </Box> */}
    </>
  );
};

export default AboutUs;
